import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { TagButtonListItem } from '@/components/ui/List/TagButtonList/TagButtonListItem';
/**
 * カテゴリーのボタンリスト
 * FIXME: 既存のページとの統一のため、デザインシステムの値とずれています。全てのページがTS化されたらまとめてデザイン修正したいです。（コラム, 選定支援事例一覧）
 * @param props
 * @returns
 */
export const TagButtonList = (props) => {
    const { activeValue, className = '', items, onClick } = props;
    return (_jsx("ul", Object.assign({ className: clsx('flex items-center flex-wrap gap-[10px]', 'bg-gray-75', 'rounded-[3px]', 'p-20', className) }, { children: items.map((item) => (_jsx(TagButtonListItem, { isActive: activeValue === item.value, label: item.label, onClick: onClick, value: item.value }, `TagButtonListItem_${item.value}`))) })));
};
